import { render, staticRenderFns } from "./Ripple.vue?vue&type=template&id=600b6f4b"
import script from "./Ripple.vue?vue&type=script&lang=js"
export * from "./Ripple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports